import normalize, {
  recommendationListSchema,
  recommendationSchema,
} from 'schema';

import {
  REMOVE_RECOMMENDATION_FROM_LIST,
  GET_DEFAULT_RECOMMENDATIONS,
  GET_DEFAULT_RECOMMENDATIONS_SUCCESS,
  GET_FILTERED_RECOMMENDATIONS,
  GET_FILTERED_RECOMMENDATIONS_SUCCESS,
  GET_MORE_RECOMMENDATIONS,
  GET_MORE_RECOMMENDATIONS_SUCCESS,
  UPDATE_RECOMMENDATION_STATUS,
  UPDATE_RECOMMENDATION_STATUS_SUCCESS,
  SET_HIDING_RECOMMENDATION,
  HIDE_RECOMMENDATION,
} from 'actionTypes';

const DEFAULT_FILTERS = {
  isHidden: false,
};

function recommendationsRequestSuccess(type, response) {
  const { results } = response.payload;
  return {
    type,
    normalizedData: normalize(results, recommendationListSchema),
    pagination: {
      recommendations: extractPagination(response),
    },
  };
}

function extractPagination(response) {
  const { count, next, previous } = response.payload;
  return {
    count,
    next: next && new URL(next).searchParams.get('page'),
    previous: previous && new URL(previous).searchParams.get('page'),
  };
}

export function removeRecommendationFromList(uuid) {
  return {
    type: REMOVE_RECOMMENDATION_FROM_LIST,
    uuid,
  };
}

// DEFAULT RECOMMENDATIONS (NO HIDDEN)
export function getDefaultRecommendations() {
  return {
    type: GET_DEFAULT_RECOMMENDATIONS,
    filters: DEFAULT_FILTERS,
  };
}

export function getDefaultRecommendationsSuccess(response) {
  return recommendationsRequestSuccess(
    GET_DEFAULT_RECOMMENDATIONS_SUCCESS,
    response
  );
}

// PAGINATION
export function getMoreRecommendations(payload) {
  return {
    type: GET_MORE_RECOMMENDATIONS,
    payload,
  };
}

export function getMoreRecommendationsSuccess(response) {
  return recommendationsRequestSuccess(
    GET_MORE_RECOMMENDATIONS_SUCCESS,
    response
  );
}

// FILTERING
export function getFilteredRecommendations(filters) {
  return {
    type: GET_FILTERED_RECOMMENDATIONS,
    filters,
  };
}

export function getFilteredRecommendationsSuccess(response) {
  return recommendationsRequestSuccess(
    GET_FILTERED_RECOMMENDATIONS_SUCCESS,
    response
  );
}

// UPDATING (FAVOURITING/HIDING)
export function updateRecommendationStatus(recommendationUuid, payload) {
  return {
    type: UPDATE_RECOMMENDATION_STATUS,
    endpointArgs: { recommendationUuid },
    payload,
  };
}

export function updateRecommendationStatusSuccess(response) {
  return {
    type: UPDATE_RECOMMENDATION_STATUS_SUCCESS,
    normalizedData: normalize(response.payload, recommendationSchema),
  };
}

export function setHidingRecommendation(uuid) {
  return {
    type: SET_HIDING_RECOMMENDATION,
    uuid,
  };
}

export function hideRecommendation(recommendation) {
  return {
    type: HIDE_RECOMMENDATION,
    recommendation,
  };
}



// WEBPACK FOOTER //
// ./src/actions/recommendationActions.js